import React, { useRef, useEffect, useState } from 'react'
import Table from '.'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { API_DEFAULT_PAGE_SIZE } from '../../const';
import { convertPageToOffsetLimit } from '../../utils';
import useFilter from '../../hooks/filter';
import Filters from '../filters';
import { getCustomers } from '../../slices/customers'
import { ExportModal } from '../export-modal';
import { Button } from '../button';
import useModal from '../../hooks/modal';


export const CustomersListTable = ({ callBack }) => {
    let { customerId } = useParams();

    const customers = useSelector((state) => state.customers)
    const navigate = useNavigate();
    const fetchCustomersPromise = useRef()
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize, setPageSize] = useState(API_DEFAULT_PAGE_SIZE)
    const [isDirty, setIsDirty] = useState(true)
    const [isShowingExportModal, toggleShowingExportModal] = useModal();

    const columns = React.useMemo(
        () => [
            {
                Header: 'Nafn',
                accessor: 'name',
            },
            {
                Header: 'Tilvísun',
                accessor: 'customer_reference',
            },
            {
                Header: 'Fjöldi áskrifta',
                accessor: 'subscription_count',
                className: 'text-end',
            }
        ])

    const filterTypes = [
        {
            type: 'choice',
            key: 'state',
            label: gettext('State'),
            choices: [
                { label: gettext('Active'), value: 'active' },
                { label: gettext('Inactive'), value: 'inactive' },
            ]
        },]

    const {
        activeFilters,
        addFilter,
        removeFilter,
        changeFilterValue,
        replaceFilter,
        updateSearchFilter,
    } = useFilter()

    const onRowClick = (row) => {
        callBack(true)
        navigate(`/customers/${row.original.id}/`)
    }


    useEffect(() => {
        setIsDirty(true)
        setCurrentPage(1)
    }, [activeFilters])
    useEffect(() => {
        setIsDirty(true)
    }, [currentPage])
    useEffect(() => {
        setIsDirty(true)
    }, [pageSize])


    useEffect(() => {
        if (isDirty) {
            const offsetLimit = convertPageToOffsetLimit(currentPage, pageSize)
            const params = [...activeFilters, ...offsetLimit]

            fetchCustomersPromise.current?.abort()
            let ignore = false
            if (!ignore) {
                fetchCustomersPromise.current = dispatch(getCustomers(params))
                setIsDirty(false)
            }
            return () => {
                ignore = true;
            };
        }
    }, [isDirty])


    return (
        <>
            <Filters
                addFilter={addFilter}
                activeFilters={activeFilters}
                filterTypes={filterTypes}
                changeFilterValue={changeFilterValue}
                removeFilter={removeFilter}
                replaceFilter={replaceFilter}
                updateSearchFilter={updateSearchFilter}
            />
            <div className="row mt-3 m-0">
                <div className="col-12 bg-02 pe-0 rounded-2">
                    <div className="row align-items-center">
                        <div className="col flex-grow-1">
                            {customers.loading ?
                                <>
                                    <div className="loader loader-small" role="status"></div>
                                </>
                                :
                                <>{customers.count} {gettext('results')}</>
                            }
                        </div>
                        <div className="col-2 min-width-116">
                            <Button className="btn btn-primary btn-fluid btn-sm ml-3" onClick={toggleShowingExportModal}>{gettext('Export')}</Button>
                            <ExportModal
                                show={isShowingExportModal}
                                onClose={toggleShowingExportModal}
                                model={'Customer'}
                                filters={activeFilters}
                                defaultTitle={gettext('Customers')}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12 overflow-scroll">
                    {customers.results.length > 0 &&
                        <Table
                            columns={columns}
                            data={customers.results}
                            onRowClick={onRowClick}
                            selectedRow={customerId}
                            totalRows={customers.count}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            pageChangeHandler={(page, pageSize) => {
                                setCurrentPage(page)
                                setPageSize(pageSize)
                            }}

                        />
                    }
                </div>
            </div>
        </>
    )
}

CustomersListTable.propTypes = {
    data: PropTypes.array,
};

CustomersListTable.defaultProps = {
    data: [],
};
